import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(amount, currency = 'EUR') {
  return new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: currency,
  }).format(amount);
}

export function formatDate(date, options = {}) {
  if (!date) return '';
  const d = new Date(date);
  return new Intl.DateTimeFormat('fr-FR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    ...options
  }).format(d);
}

export function formatDateTime(date) {
  if (!date) return '';
  const d = new Date(date);
  return new Intl.DateTimeFormat('fr-FR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(d);
}

export function getInitials(firstName, lastName) {
  return `${firstName?.charAt(0) || ''}${lastName?.charAt(0) || ''}`.toUpperCase();
}

export function getStatusColor(status) {
  const colors = {
    draft: 'status-draft',
    sent: 'status-sent',
    accepted: 'status-accepted',
    rejected: 'status-rejected',
    converted: 'status-converted',
    paid: 'status-paid',
    overdue: 'status-overdue',
    cancelled: 'status-rejected',
  };
  return colors[status] || 'status-draft';
}

export function getPeppolStatusColor(status) {
  const colors = {
    none: 'peppol-none',
    pending: 'peppol-pending',
    certified: 'peppol-certified',
    ready: 'peppol-certified',
    failed: 'peppol-failed',
  };
  return colors[status] || 'peppol-none';
}

export function getStageColor(stage) {
  const colors = {
    lead: '#94A3B8',
    qualified: '#3B82F6',
    proposal: '#F59E0B',
    negotiation: '#8B5CF6',
    won: '#10B981',
    lost: '#EF4444',
  };
  return colors[stage] || '#94A3B8';
}

export function getStageName(stage) {
  const names = {
    lead: 'Lead',
    qualified: 'Qualifié',
    proposal: 'Proposition',
    negotiation: 'Négociation',
    won: 'Gagné',
    lost: 'Perdu',
  };
  return names[stage] || stage;
}

export function getStatusName(status) {
  const names = {
    draft: 'Brouillon',
    sent: 'Envoyé',
    accepted: 'Accepté',
    rejected: 'Rejeté',
    converted: 'Converti',
    paid: 'Payé',
    overdue: 'En retard',
    cancelled: 'Annulé',
  };
  return names[status] || status;
}

export function getPeppolStatusName(status) {
  const names = {
    none: 'Non vérifié',
    pending: 'En attente',
    certified: 'Conforme Peppol',
    ready: 'Conforme Peppol',
    failed: 'Données manquantes',
  };
  return names[status] || status;
}

export function calculateLineTotal(item) {
  const subtotal = (item.quantity || 1) * (item.unit_price || 0);
  const discount = subtotal * ((item.discount || 0) / 100);
  const taxable = subtotal - discount;
  const tax = taxable * ((item.tax_rate || 20) / 100);
  return taxable + tax;
}

export function calculateDocumentTotals(items) {
  let subtotal = 0;
  let taxTotal = 0;
  let discountTotal = 0;
  (items || []).forEach((item) => {
    const lineSubtotal = (item.quantity || 0) * (item.unit_price || 0);
    const lineDiscount = lineSubtotal * ((item.discount || 0) / 100);
    const lineTaxable = lineSubtotal - lineDiscount;
    const lineTax = lineTaxable * ((item.tax_rate || 0) / 100);
    subtotal += lineSubtotal;
    discountTotal += lineDiscount;
    taxTotal += lineTax;
  });
  return {
    subtotal,
    taxTotal,
    discountTotal,
    total: subtotal - discountTotal + taxTotal,
  };
}

export function generateId() {
  return Math.random().toString(36).substr(2, 9);
}
